import { Controller } from "@hotwired/stimulus"

// Bootstrap's offcanvas already gives us focus trap, Escape-to-close, scrim
// click and body scroll lock for free. Turbo navigation doesn't fire any of
// Bootstrap's own events, so this only has to close the drawer on page change.
export default class extends Controller {
  connect() {
    this.handleLoad = () => this.close()
    document.addEventListener("turbo:load", this.handleLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.handleLoad)
  }

  close() {
    window.bootstrap.Offcanvas.getInstance(this.element)?.hide()
  }
}
